import MonthEvent from './MonthEvent.view';

export default MonthEvent;
